import type { MessageKey, MessageOverrides } from "./types";

export type { MessageKey, MessageOverrides };

// The website's built-in interface text. It lives on the website (its admin API sends it with the interface text); the
// Interface text screen fills this in before it shows (pages.tsx).
export const DEFAULT_MESSAGES: { en: Record<string, string>; ar: Record<string, string> } = { en: {}, ar: {} };

export function setDefaultMessages(defaults: { en: Record<string, string>; ar: Record<string, string> }) {
  DEFAULT_MESSAGES.en = defaults.en;
  DEFAULT_MESSAGES.ar = defaults.ar;
}
